import { defineComponent as _defineComponent } from 'vue'
import { ref } from "@nuxtjs/composition-api";
import CCoachmark from "@rscollabs/capsule-wardrobe-components/src/components/CCoachmark/CCoachmark.vue";
import { onMounted, onUnmounted } from "vue";

import { throttle, useAmplitude } from "@/composables";
import { LTK_COACHMARK_CLASS_NAME } from "@/utils/constants";
import { observeElementVisibility } from "@/utils/element-observer";


export default /*#__PURE__*/_defineComponent({
  __name: 'LtkCoachmark',
  props: {
  text: {
    type: String,
    required: true,
  },
  top: {
    type: String,
    default: undefined,
  },
  bottom: {
    type: String,
    default: undefined,
  },
  tailTop: {
    type: String,
    default: undefined,
  },
  tailBottom: {
    type: String,
    default: undefined,
  },
  tailLeft: {
    type: String,
    default: undefined,
  },
  tailRight: {
    type: String,
    default: undefined,
  },
  tailPointUp: {
    type: Boolean,
  },
  tailPointDown: {
    type: Boolean,
  },
  vpmType: {
    type: String,
    default: undefined,
  },
  dismissOnWindowClick: {
    type: Boolean,
    default: false,
  },
  dismissOnWindowScroll: {
    type: Boolean,
    default: false,
  },
  dismissScrollHeight: {
    // default to 150 because it is the correct value for the fist use case implemented
    // this number should likely be different for any other use case
    type: Number,
    default: 150,
  },
  // a delay in millis before calling handleIsDisplayedInViewport
  displayedInViewportDelay: {
    type: Number,
    default: 0,
  },
  handleIsDisplayedInViewport: {
    type: Function,
    default: null,
  },
},
  setup(__props) {

const props = __props;



const amplitude = useAmplitude();

const showCoachmark = ref(true);
const coachmarkElement = ref<InstanceType<typeof CCoachmark> | null>(null);
let cleanupObservers: (() => void) | null = null;

const onDismiss = async () => {
  showCoachmark.value = false;

  if (props.vpmType && amplitude) {
    amplitude.sendEvent("/dismiss-web-vpm", { "vpm-type": props.vpmType });
  } else if (props.vpmType && process.client && window.$nuxt) {
    // fallback for when the component is extended and mounted
    await window.$nuxt.$amplitude?.sendEvent("/dismiss-web-vpm", { "vpm-type": props.vpmType });
  }

  // cleanup buttons pushed through overlay
  const nodeListFollow = document.querySelectorAll("#coachmarkTarget");
  nodeListFollow.forEach((node) => node.removeAttribute("style"));

  cleanupObservers?.();
  cleanupObservers = null;
};

const initGlobalClickDismissListener = () => {
  window.addEventListener(
    "click",
    () => {
      onDismiss();
    },
    { once: true },
  );
};

const initGlobalScrollDismissListener = () => {
  const SCROLL_THROTLE = 50;

  const throttledScroll = throttle(() => {
    if (window.scrollY > props.dismissScrollHeight) {
      onDismiss();
      window.removeEventListener("scroll", throttledScroll);
    }
  }, SCROLL_THROTLE);

  window.addEventListener("scroll", throttledScroll);
};

onMounted(() => {
  if (props.dismissOnWindowClick) {
    initGlobalClickDismissListener();
  }

  if (props.dismissOnWindowScroll) {
    initGlobalScrollDismissListener();
  }

  if (props.handleIsDisplayedInViewport && coachmarkElement.value) {
    if (coachmarkElement.value?.$el) {
      cleanupObservers = observeElementVisibility(
        coachmarkElement.value?.$el,
        props.displayedInViewportDelay,
        props.handleIsDisplayedInViewport as () => unknown,
      );
    }
  }
});

onUnmounted(() => {
  cleanupObservers?.();
});

return { __sfc: true,props, amplitude, showCoachmark, coachmarkElement, cleanupObservers, onDismiss, initGlobalClickDismissListener, initGlobalScrollDismissListener, CCoachmark, LTK_COACHMARK_CLASS_NAME }
}

})